/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DiagnosisIcd10View } from './DiagnosisIcd10View';

export type DiagnosisView = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    description?: string;
    examinationId?: string;
    employeeId?: string;
    status?: DiagnosisView.status;
    protocolNo?: number;
    diagnosisIcd10s?: Array<DiagnosisIcd10View>;
    occupationalDiseasePreDiagnosis?: boolean;
    workRelatedDiseaseDiagnosis?: boolean;
}

export namespace DiagnosisView {

    export enum status {
        DELETED = 'DELETED',
        ACTIVE = 'ACTIVE',
        NURSE_OPERATION = 'NURSE_OPERATION',
        ARCHIVED = 'ARCHIVED',
        PASSIVE = 'PASSIVE',
    }


}
